import { render } from "./ActivateAccount.vue?vue&type=template&id=1c30f79f"
import script from "./ActivateAccount.vue?vue&type=script&lang=js"
export * from "./ActivateAccount.vue?vue&type=script&lang=js"

import "./ActivateAccount.vue?vue&type=style&index=0&id=1c30f79f&lang=scss"
script.render = render

export default script